import { jsx as _jsx } from "react/jsx-runtime";
import cx from '../../utils/classNames';
import styles from './SkeletonThumbnail.module.css';
const SkeletonThumbnail = ({ className, height = 16, width = 16, opacityIndex = 0, }) => {
    return (_jsx("div", { className: cx(className, styles.skeletonThumbnail, styles[`skeletonThumbnail${opacityIndex}`]), style: { width: `${width}px`, height: `${height}px` } }, void 0));
};
export default SkeletonThumbnail;
